// types
import { i18nEaiBalanceGroups } from 'models/i18n';

// ==============================|| I18N SK BALANCE GROUPS ||============================== //

const skEaiBalanceGroups: i18nEaiBalanceGroups = {
  balanceGroupList: {
    searchInput: 'Zadajte EIC / názov',
    columns: {
      name: 'Názov',
      eic: 'EIC',
      emsPartyName: 'Účastník trhu'
    }
  },
  balanceGroupProperties: {
    title: 'Vlastnosti',
    deviationSubCardTitle: 'Limit špekulácie s SI bilančnej skupiny',
    limit: 'Limit špekulácie [MWh]',
    period: 'Perióda',
    optimizedPeriodNumberSelectLabel:
      'Počet predikovaných a plánovaných periód pre AI',
    productionModelTitle: 'Model nominácie bilančnej skupiny'
  },
  balanceGroupData: {
    title: 'Informácie o bilančnej skupine',
    basicInfo: 'Základné informácie'
  },
  balanceGroupDeliveryPointList: {
    title: 'Zoznam OOM',
    columns: {
      name: 'Názov odberného miesta',
      eic: 'EIC',
      id: 'ID',
      actions: 'Actions'
    }
  },
  input: {
    eic: 'EIC',
    name: 'Názov bilančnej skupiny',
    emsPartyName: 'Účastník trhu'
  },
  validation: {
    'name-required': 'Meno bilančnej skupiny je povinné',
    'eic-required': 'EIC je povinné',
    'eic-length': 'Dĺžka musí byť 16',
    'eic-available': 'Hodnota EIC musí byť unikátna'
  }
};

export default skEaiBalanceGroups;
